/**
 * URL Fixer Utility
 * Fixes URLs that point to old/test servers and redirects them to the current server
 */

const OLD_DOMAINS = [
  'https://kaha-api-test.masovison.com',
  'https://api-test.kaha.com.np',
  'https://test-api.kaha.com.np',
];

const getCurrentDomain = () => {
  const currentUrl = window.location.origin;
  // Extract the base API domain from current URL
  // If on https://kaha.com.np, API is likely https://api.kaha.com.np
  if (currentUrl.includes('kaha.com.np')) {
    return 'https://api.kaha.com.np';
  }
  return currentUrl;
};

/**
 * Fix URLs that point to old test servers
 * @param {string} url - The URL to fix
 * @returns {string} - The fixed URL
 */
export const fixImageUrl = (url) => {
  if (!url) return url;
  
  console.log('fixImageUrl: Input URL:', url);
  
  // Check if URL starts with any old domain
  for (const oldDomain of OLD_DOMAINS) {
    if (url.startsWith(oldDomain)) {
      // Replace old domain with current domain
      const currentDomain = getCurrentDomain();
      const fixed = url.replace(oldDomain, currentDomain);
      console.log('fixImageUrl: Replaced', oldDomain, 'with', currentDomain, '→', fixed);
      return fixed;
    }
  }
  
  console.log('fixImageUrl: No old domain found, returning original URL');
  return url;
};

/**
 * Fix all image URLs in an object recursively
 * @param {object} obj - The object to fix
 * @returns {object} - The fixed object
 */
export const fixImageUrlsInObject = (obj) => {
  if (!obj) return obj;
  
  if (typeof obj !== 'object') return obj;
  
  if (Array.isArray(obj)) {
    return obj.map(item => fixImageUrlsInObject(item));
  }
  
  const fixed = { ...obj };
  
  // Fix common image URL fields
  const imageFields = ['iconUrl', 'icon', 'avatar', 'coverImageUrl', 'buildingImageUrl', 'imageUrl', 'url'];
  
  for (const field of imageFields) {
    if (fixed[field] && typeof fixed[field] === 'string') {
      fixed[field] = fixImageUrl(fixed[field]);
    }
  }
  
  // Recursively fix nested objects
  for (const key in fixed) {
    if (typeof fixed[key] === 'object' && fixed[key] !== null) {
      fixed[key] = fixImageUrlsInObject(fixed[key]);
    }
  }
  
  return fixed;
};
